import { IReduxAction } from '../IReduxAction'
import { USER_ACTION_TYPES } from './types'

export interface IUserState {
  data: any
  auth: any
  users: any[]
  errorCode: string
  errorMessage: string
}

export const initState: IUserState = {
  auth: null,
  data: null,
  users: [],
  errorCode: '',
  errorMessage: ''
}

export default (state = initState, action: IReduxAction): IUserState => {
  const { data } = state

  switch (action.type) {
    case USER_ACTION_TYPES.login_begins:
    case USER_ACTION_TYPES.signup_begins:
    case USER_ACTION_TYPES.signup_without_pass_begins:
    case USER_ACTION_TYPES.logout_begins:
      return { ...initState }

    case USER_ACTION_TYPES.login_success:
    case USER_ACTION_TYPES.signup_success:
    case USER_ACTION_TYPES.signup_without_pass_success:
      return {
        ...initState,
        auth: { ...action.payload.data.userAuth },
        data: { ...action.payload.data.userData }
      }

    case USER_ACTION_TYPES.login_error:
    case USER_ACTION_TYPES.signup_error:
    case USER_ACTION_TYPES.signup_without_pass_error:
    case USER_ACTION_TYPES.logout_error:
      return {
        ...initState,
        errorCode: action.payload.data.code,
        errorMessage: action.payload.data.message
      }

    case USER_ACTION_TYPES.logout_success:
      return { ...initState }

    case USER_ACTION_TYPES.save_user_begins:
      return {
        ...state,
        users: []
      }

    case USER_ACTION_TYPES.save_user_success:
      const { users } = state
      const { user } = action.payload.data
      const currentUser = users.find(
        item => item && item.userId === user.userId
      )

      if (!currentUser) {
        users.push(user)
      }

      return {
        ...state,
        users
      }

    case USER_ACTION_TYPES.save_user_error:
      return {
        ...state,
        errorCode: action.payload.data.code,
        errorMessage: action.payload.data.message
      }

    case USER_ACTION_TYPES.update_image:
      data.avatar_url = action.payload.data.url
      // data.terms_not_accepted = null
      return {
        ...state,
        data
      }

    case USER_ACTION_TYPES.update_user_success:
      const { userData } = action.payload.data

      return {
        ...state,
        data: {
          ...userData

          // terms_not_accepted: null
        }
      }

    case USER_ACTION_TYPES.update_parental_instructions_complete:
      const currUsers = state.users
      const currUserEmail = state.data?.email

      const updatedUsers = currUsers.map(currUser =>
        currUser?.email === currUserEmail
          ? { ...currUser, parental_instructions_complete: true }
          : currUser
      )

      return {
        ...state,
        data: { ...data, parental_instructions_complete: true },
        users: updatedUsers
      }

    case USER_ACTION_TYPES.send_verification_email:
      const { isSendVerificationEmail } = action.payload.data

      return {
        ...state,
        auth: {
          ...state.auth,
          isSendVerificationEmail
        }
      }

    case USER_ACTION_TYPES.set_is_phone_number:
      const { isGetPhoneNumber } = action.payload.data
      return {
        ...state,
        auth: {
          ...state.auth,
          isGetPhoneNumber
        }
      }

    // case USER_ACTION_TYPES.need_verify_user_in_mixpanel:
    //   const { bool } = action.payload.data

    //   return {
    //     ...state,
    //     data: { ...data, need_verify_user_in_mixpanel: bool }
    //   }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/user/index.ts